import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFetchSpecifications from '../../../hooks/specifications/useFetchSpecifications';
import { updateVehicleAction } from '../../../redux/actions/vehicleActions';
import { convertToVehicleRequest } from '../../../utils/requestMapper';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import VehicleForm from '../forms/VehicleForm';

const UpdateVehicleModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [updating, setUpdating] = useState(false);
  const { specifications, loading } = useFetchSpecifications();
  const vehicle = useSelector((state) => state.vehicle?.vehicle);

  const onSubmit = async (data) => {
    setUpdating(true);
    const vehicleRequest = convertToVehicleRequest(data);
    await dispatch(updateVehicleAction(vehicle.vin, vehicleRequest));
    setUpdating(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Редагувати автомобіль'}
      loading={loading}
      onClose={onModalClose}
      body={
        !loading && (
          <VehicleForm
            readOnly={false}
            onSubmit={onSubmit}
            loading={updating}
            vehicle={vehicle}
            isUpdating={true}
            specifications={specifications}
          />
        )
      }
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'vehicle-form'} children={'Зберегти'} />
      }
    />
  );
};

export default UpdateVehicleModal;
